import React from 'react';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import ProjectGroupView from './View';
import projectGroupBlockSchema from './schema';

export const ProjectGroupEdit = (props) => {
  const {
    block,
    blocksErrors,
    blocksConfig,
    onChangeBlock,
    data,
    selected,
    intl,
  } = props;

  let schema = projectGroupBlockSchema({ data, intl });

  return (
    <>
      <ProjectGroupView
        {...props}
        path={getBaseUrl(props.pathname)}
        mode="edit"
      />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          onChangeBlock={onChangeBlock}
          formData={data}
          errors={blocksErrors}
          blocksConfig={blocksConfig}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

export default ProjectGroupEdit;
